var _circle, _path, _g, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreecreditscore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 23,
    fill: "#B5D7FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4033_1489",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 48,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41602 10.6665H55.0827V37.3332H8.41602V10.6665Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4033_1489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0121 55.1906C43.4003 55.1906 52.6121 45.852 52.6121 34.3573C52.6121 22.8625 43.4003 13.5239 32.0121 13.5239C20.6239 13.5239 11.4121 22.8625 11.4121 34.3573C11.4121 45.852 20.6239 55.1906 32.0121 55.1906Z",
    fill: "white",
    stroke: "#166BCD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 23.2362C44.6523 22.8052 45.3873 22.8359 45.7863 23.3347C48.0536 26.1687 49.3953 29.6432 49.6114 33.285C49.8276 36.9267 48.9062 40.5356 46.99 43.6178C46.6527 44.1603 45.9266 44.2777 45.4074 43.9055L41.8904 41.3845C41.3713 41.0123 41.258 40.2923 41.5734 39.7368C42.6145 37.903 43.1085 35.7997 42.9826 33.6784C42.8567 31.5571 42.1174 29.5269 40.8668 27.8291C40.4879 27.3148 40.5152 26.5864 40.9867 26.1555L44.1808 23.2362Z",
    fill: "#CEE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6103 21.6233C21.2048 21.1297 21.2743 20.3974 21.7934 20.0252C24.7102 17.9344 28.2054 16.7798 31.8122 16.732C35.4191 16.6842 38.9436 17.7459 41.9147 19.7587C42.4436 20.117 42.5324 20.8472 42.1402 21.3514L39.4831 24.7668C39.0909 25.271 38.3669 25.3558 37.8242 25.0189C36.0541 23.9199 33.9995 23.3441 31.9002 23.3719C29.8009 23.3997 27.7623 24.0298 26.0218 25.1752C25.4883 25.5264 24.7623 25.4607 24.3569 24.9671L21.6103 21.6233Z",
    fill: "#7EB3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5902 39.9335C15.9897 40.1513 15.3224 39.8419 15.1445 39.2284C14.375 36.5747 14.2396 33.7714 14.7569 31.0462C15.2741 28.321 16.4271 25.7622 18.1154 23.575C18.5057 23.0694 19.24 23.026 19.7189 23.4487L22.9633 26.3121C23.4422 26.7347 23.4821 27.4626 23.1123 27.9834C22.2021 29.2649 21.5757 30.7313 21.2809 32.2844C20.9861 33.8376 21.0317 35.4315 21.4091 36.9574C21.5624 37.5775 21.2586 38.2401 20.6581 38.4579L16.5902 39.9335Z",
    fill: "#166BCD"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5132 31.2528C29.7124 31.9202 29.6222 33.0729 30.3112 33.8309C31.0053 34.5941 32.2108 34.6674 33.0115 33.9997L33.5059 33.374L39.2847 25.9761L30.999 30.9593L30.5132 31.2528Z",
    fill: "#166BCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3397 36.5845H10.8529C10.2141 36.5845 9.69629 37.1023 9.69629 37.7411V38.3127C9.69629 38.9515 10.2141 39.4694 10.8529 39.4694H53.3397C53.9785 39.4694 54.4963 38.9515 54.4963 38.3127V37.7411C54.4963 37.1023 53.9785 36.5845 53.3397 36.5845Z",
    fill: "#166BCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1399 42.1846H22.0531C21.4143 42.1846 20.8965 42.7024 20.8965 43.3412V43.7431C20.8965 44.3819 21.4143 44.8998 22.0531 44.8998H42.1399C42.7786 44.8998 43.2965 44.3819 43.2965 43.7431V43.3412C43.2965 42.7024 42.7786 42.1846 42.1399 42.1846Z",
    fill: "#7EB3F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreecreditscore);
export default __webpack_public_path__ + "static/media/freecreditscore.5a100fb0b24c6ad5729acb88b81cf24c.svg";
export { ForwardRef as ReactComponent };